import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateSellerDetails } from '@/data/api/request/sellerRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateSellerDetails() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: {
      sellerId: string;
      data: {
        minOrderAmount?: string;
      };
    }) => {
      const minOrderAmount =
        args.data.minOrderAmount === undefined
          ? undefined
          : Number(args.data.minOrderAmount);
      await updateSellerDetails({
        sellerId: args.sellerId,
        updateSellerDetailsRequest: {
          min_order_amount: minOrderAmount,
        },
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.seller.list] });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.seller.details, variables.sellerId],
      });
      showSnackSuccess('Datos actualizados');
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });

  return mutation;
}
